module.exports = __webpack_public_path__ + "static/img/11.bab7369.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/imgs/11.png
// module id = 00pq
// module chunks = 0